import {
  CLEAR_PREVIEW_CONTENT_MEDIA,
  GET_PREVIEW_GET_MEDIA_REQUEST_ERROR,
  GET_PREVIEW_GET_MEDIA_REQUEST_SUCCESS,
  GET_PREVIEW_MEDIA_REQUEST_INIT,
} from '../actions/preview/constants';

const initialState = {
  loading: false,
  media: null,
  error: null,
  isPlaying: false,
  isFinished: false,
};

export default function previewReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PREVIEW_MEDIA_REQUEST_INIT:
      return { ...initialState, loading: true };
    case GET_PREVIEW_GET_MEDIA_REQUEST_SUCCESS:
      return { ...state, loading: false, media: action.media };
    case GET_PREVIEW_GET_MEDIA_REQUEST_ERROR:
      return { ...initialState, error: action.error };
    case CLEAR_PREVIEW_CONTENT_MEDIA:
      return { ...initialState };
    default:
      return state;
  }
}
